export const queryKeys = {
  me: ['me'] as const,
  newHires: ['new-hires'] as const,
  reviewers: ['reviewers'] as const,
  qaAssignments: (params?: Record<string, unknown>) => ['qa-assignments', params ?? {}] as const,
  qaAssignmentsChart: ['qa-assignments', 'chart'] as const,
  spotchecks: ['spotchecks'] as const,
  stats: ['stats'] as const,
  zendeskTicket: (id: string) => ['zendesk', 'ticket', id] as const,
  feedbackResults: (userId: string) => ['feedback', 'results', userId] as const,
};
